(function () {
  'use strict';

  if (window.__siteSearchBound) return;
  window.__siteSearchBound = true;

  var PANEL_FALLBACK_MS = 1100;
  var RECENTS_KEY = 'joselito-search-recents';
  var RECENTS_MAX = 8;
  var SEARCH_DEBOUNCE_MS = 250;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function overlayRoot() {
    return document.querySelector('[data-search-overlay]');
  }

  function closeHeaderDrawer() {
    var drawer = document.querySelector('[data-header-drawer]');
    if (drawer && drawer.open) drawer.close();
  }

  function normalizeQuery(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function truncate(value, max) {
    var text = String(value || '');
    if (text.length <= max) return text;
    return text.slice(0, max).replace(/\s+\S*$/, '').trim();
  }

  function readStoredRecents() {
    try {
      var raw = window.localStorage.getItem(RECENTS_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(normalizeQuery)
        .filter(Boolean)
        .slice(0, RECENTS_MAX);
    } catch (e) {
      return [];
    }
  }

  function writeStoredRecents(items) {
    try {
      window.localStorage.setItem(RECENTS_KEY, JSON.stringify(items.slice(0, RECENTS_MAX)));
    } catch (e) {}
  }

  function seedRecentsIfNeeded(root) {
    if (!root || readStoredRecents().length) return;
    var raw = root.getAttribute('data-search-seed-samples');
    if (!raw) return;
    try {
      var seeds = JSON.parse(raw);
      if (!Array.isArray(seeds) || !seeds.length) return;
      writeStoredRecents(
        seeds
          .map(normalizeQuery)
          .filter(Boolean)
          .slice(0, RECENTS_MAX)
      );
    } catch (e) {}
  }

  function addRecent(query) {
    var q = normalizeQuery(query);
    if (!q) return;
    var next = [q].concat(
      readStoredRecents().filter(function (item) {
        return item.toLowerCase() !== q.toLowerCase();
      })
    );
    writeStoredRecents(next);
  }

  function clearStoredRecents() {
    try {
      window.localStorage.removeItem(RECENTS_KEY);
    } catch (e) {}
  }

  function renderRecents(root) {
    if (!root) return;
    seedRecentsIfNeeded(root);
    var list = root.querySelector('[data-search-recents-list]');
    var recents = root.querySelector('[data-search-recents]');
    if (!list || !recents) return;

    var items = readStoredRecents();
    list.textContent = '';
    items.forEach(function (term) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'site-search__recent cta-02';
      btn.setAttribute('data-search-recent', '');
      btn.textContent = term;
      li.appendChild(btn);
      list.appendChild(li);
    });

    var hasChips = items.length > 0;
    recents.querySelectorAll('[data-search-recents-clear]').forEach(function (btn) {
      btn.hidden = !hasChips;
    });
    syncFilled(root);
  }

  function syncFilled(root) {
    if (!root) return;
    var input = root.querySelector('[data-search-input]');
    var clearBtn = root.querySelector('[data-search-clear]');
    var recents = root.querySelector('[data-search-recents]');
    var typing = Boolean(input && input.value.length > 0);
    var hasChips = Boolean(recents && recents.querySelector('[data-search-recent]'));

    root.classList.toggle('is-filled', typing);
    root.classList.toggle('is-typing', typing);
    if (clearBtn) clearBtn.hidden = !typing;
    if (recents) {
      var showRecents = !typing && hasChips;
      recents.hidden = !showRecents;
      recents.setAttribute('aria-hidden', showRecents ? 'false' : 'true');
    }
  }

  function contentRows(root) {
    if (root._contentRows) return root._contentRows;
    var script = root.querySelector('[data-search-content-rows]');
    var rows = [];
    if (script && script.textContent) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (Array.isArray(parsed)) rows = parsed;
      } catch (e) {}
    }
    root._contentRows = rows;
    return rows;
  }

  function rowIconHTML(root) {
    if (root._rowIconHTML != null) return root._rowIconHTML;
    var tpl = root.querySelector('[data-search-row-icon]');
    root._rowIconHTML = tpl ? tpl.innerHTML : '';
    return root._rowIconHTML;
  }

  function snapshotIdle(root) {
    if (!root || root._idleSnapshot) return;
    var products = root.querySelector('[data-search-products]');
    var list = root.querySelector('[data-search-products-list]');
    var heading = root.querySelector('[data-search-products-heading]');
    var rows = root.querySelector('[data-search-rows]');
    root._idleSnapshot = {
      productsHidden: Boolean(products && products.hidden),
      productsHTML: list ? list.innerHTML : '',
      headingHTML: heading ? heading.innerHTML : '',
      headingMuted: Boolean(heading && heading.classList.contains('is-count')),
      rowsHidden: Boolean(rows && rows.hidden),
      rowsHTML: rows ? rows.innerHTML : '',
    };
  }

  function restoreIdle(root) {
    if (!root || !root._idleSnapshot) return;
    var snap = root._idleSnapshot;
    var products = root.querySelector('[data-search-products]');
    var list = root.querySelector('[data-search-products-list]');
    var heading = root.querySelector('[data-search-products-heading]');
    var rows = root.querySelector('[data-search-rows]');
    if (products) products.hidden = snap.productsHidden;
    if (list) list.innerHTML = snap.productsHTML;
    if (heading) {
      heading.innerHTML = snap.headingHTML;
      heading.classList.toggle('is-count', snap.headingMuted);
    }
    if (rows) {
      rows.hidden = snap.rowsHidden;
      rows.innerHTML = snap.rowsHTML;
    }
    hideStatus(root);
    root.classList.remove('is-results', 'is-empty', 'is-searching');
  }

  function hideStatus(root) {
    var status = root.querySelector('[data-search-status]');
    var queryEl = root.querySelector('[data-search-status-query]');
    if (status) status.hidden = true;
    if (queryEl) {
      queryEl.hidden = true;
      queryEl.textContent = '';
    }
    root.classList.remove('is-searching', 'is-empty');
  }

  function showSearching(root) {
    var status = root.querySelector('[data-search-status]');
    var label = root.querySelector('[data-search-status-label]');
    var queryEl = root.querySelector('[data-search-status-query]');
    if (!status || !label) return;
    label.textContent = root.getAttribute('data-searching') || '';
    if (queryEl) {
      queryEl.hidden = true;
      queryEl.textContent = '';
    }
    status.hidden = false;
    root.classList.add('is-searching');
    root.classList.remove('is-empty');
  }

  function formatMoney(price, format) {
    var amount = Number(price);
    if (isNaN(amount)) return '';
    var cents = Math.round(amount * 100);
    var formatString = format || '{{amount}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    var key = match ? match[1] : 'amount';

    function withDelimiters(number, precision, thousands, decimal) {
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }
    return formatString.replace(placeholder, value);
  }

  function cdnWidth(url, width) {
    if (!url) return '';
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function productImage(product, fallback) {
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.image) return product.image;
    return fallback || '';
  }

  function productCardHTML(product, root) {
    var title = product.title || '';
    var url = product.url || '#';
    var price = formatMoney(product.price, root.getAttribute('data-money-format'));
    var available = product.available !== false;
    var fallback = root.getAttribute('data-product-fallback') || '';
    var image = productImage(product, fallback);
    var alt =
      (product.featured_image && product.featured_image.alt) || product.title || title;
    var soldOut = root.getAttribute('data-sold-out') || '';
    var tag = available
      ? ''
      : '<span class="card-grid__tag label-1">' + escapeHtml(soldOut) + '</span>';
    return (
      '<li class="card-grid__card">' +
      '<a class="card-grid__card-link" href="' +
      escapeHtml(url) +
      '">' +
      '<span class="card-grid__frame">' +
      '<img class="card-grid__image" src="' +
      escapeHtml(cdnWidth(image, 800)) +
      '" alt="' +
      escapeHtml(alt) +
      '" width="373" height="497" loading="lazy">' +
      tag +
      '</span>' +
      '<span class="card-grid__box">' +
      '<span class="card-grid__title body-4">' +
      escapeHtml(title) +
      '</span>' +
      '<span class="card-grid__price body-4">' +
      escapeHtml(price) +
      '</span>' +
      '</span>' +
      '</a>' +
      '</li>'
    );
  }

  function urlsMatch(a, b) {
    if (!a || !b) return false;
    try {
      var left = new URL(a, window.location.origin);
      var right = new URL(b, window.location.origin);
      var pathA = left.pathname.replace(/\/+$/, '');
      var pathB = right.pathname.replace(/\/+$/, '');
      if (pathA === pathB) return true;
      var partsA = pathA.split('/');
      var partsB = pathB.split('/');
      return partsA[partsA.length - 1] === partsB[partsB.length - 1];
    } catch (e) {
      return String(a) === String(b);
    }
  }

  function eyebrowForPage(page, rows) {
    var url = page.url || '';
    for (var i = 0; i < rows.length; i++) {
      if (urlsMatch(url, rows[i].url)) return rows[i].eyebrow || '';
    }
    return '';
  }

  function contentRowHTML(page, root, scheme) {
    var title = truncate(page.title || '', 80);
    if (!title) return '';
    var eyebrow = eyebrowForPage(page, contentRows(root));
    var url = page.url || '#';
    var rowScheme = scheme || 'light-white';
    var eyebrowHTML = eyebrow
      ? '<p class="nav-direct-link__eyebrow label-2">' + escapeHtml(eyebrow) + '</p>'
      : '<span class="nav-direct-link__eyebrow nav-direct-link__eyebrow--empty" aria-hidden="true"></span>';
    return (
      '<div class="nav-direct-link scheme-' +
      escapeHtml(rowScheme) +
      '">' +
      '<article class="nav-direct-link__row nav-direct-link__row--link">' +
      '<a class="nav-direct-link__chrome" href="' +
      escapeHtml(url) +
      '">' +
      eyebrowHTML +
      '<p class="nav-direct-link__title title-2">' +
      escapeHtml(title) +
      '</p>' +
      '<div class="nav-direct-link__actions">' +
      '<span class="nav-direct-link__icon" aria-hidden="true">' +
      rowIconHTML(root) +
      '</span>' +
      '</div>' +
      '</a>' +
      '</article>' +
      '</div>'
    );
  }

  function resultsHeading(root, count) {
    var key = count === 1 ? 'data-results-one' : 'data-results-other';
    var template = root.getAttribute(key) || String(count);
    return template.replace(/__N__/g, String(count));
  }

  function renderResults(root, products, pages) {
    snapshotIdle(root);
    var productsEl = root.querySelector('[data-search-products]');
    var list = root.querySelector('[data-search-products-list]');
    var heading = root.querySelector('[data-search-products-heading]');
    var rows = root.querySelector('[data-search-rows]');
    hideStatus(root);
    root.classList.add('is-results');
    root.classList.remove('is-empty', 'is-searching');

    if (productsEl && list && heading) {
      if (products.length) {
        heading.textContent = resultsHeading(root, products.length);
        heading.classList.add('is-count');
        list.innerHTML = products
          .map(function (item) {
            return productCardHTML(item, root);
          })
          .join('');
        productsEl.hidden = false;
      } else {
        list.innerHTML = '';
        productsEl.hidden = true;
      }
    }

    if (rows) {
      if (pages.length) {
        rows.innerHTML = pages
          .map(function (page) {
            return contentRowHTML(page, root, 'light-white');
          })
          .join('');
        rows.hidden = false;
      } else {
        rows.innerHTML = '';
        rows.hidden = true;
      }
    }
  }

  function renderEmpty(root, query) {
    snapshotIdle(root);
    restoreIdle(root);
    var status = root.querySelector('[data-search-status]');
    var label = root.querySelector('[data-search-status-label]');
    var queryEl = root.querySelector('[data-search-status-query]');
    if (status && label) {
      label.textContent = root.getAttribute('data-no-results') || '';
      if (queryEl) {
        queryEl.textContent = '“' + query + '”';
        queryEl.hidden = false;
      }
      status.hidden = false;
    }
    root.classList.add('is-empty');
    root.classList.remove('is-searching', 'is-results');
  }

  function predictiveUrl(root, query) {
    var base = root.getAttribute('data-predictive-search-url') || '/search/suggest.json';
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product,page');
    params.set('resources[limit]', '10');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'last');
    return base + '?' + params.toString();
  }

  function clearSearchTimer(root) {
    if (root._searchTimer) {
      window.clearTimeout(root._searchTimer);
      root._searchTimer = null;
    }
  }

  function abortSearch(root) {
    if (root._searchAbort) {
      root._searchAbort.abort();
      root._searchAbort = null;
    }
  }

  function fetchPredictive(root, query) {
    abortSearch(root);
    var controller = new AbortController();
    root._searchAbort = controller;
    return fetch(predictiveUrl(root, query), {
      signal: controller.signal,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('search');
        return response.json();
      })
      .then(function (data) {
        var resources = (data && data.resources && data.resources.results) || {};
        return {
          products: Array.isArray(resources.products) ? resources.products : [],
          pages: Array.isArray(resources.pages) ? resources.pages : [],
        };
      });
  }

  function runSearch(root, query, saveRecent) {
    var q = normalizeQuery(query);
    if (!q) {
      abortSearch(root);
      restoreIdle(root);
      return;
    }
    snapshotIdle(root);
    showSearching(root);
    if (saveRecent) addRecent(q);
    fetchPredictive(root, q)
      .then(function (result) {
        if (normalizeQuery((root.querySelector('[data-search-input]') || {}).value) !== q) return;
        if (!result.products.length && !result.pages.length) {
          renderEmpty(root, q);
          return;
        }
        renderResults(root, result.products, result.pages);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (normalizeQuery((root.querySelector('[data-search-input]') || {}).value) !== q) return;
        renderEmpty(root, q);
      });
  }

  function scheduleSearch(root, query) {
    clearSearchTimer(root);
    var q = normalizeQuery(query);
    if (!q) {
      abortSearch(root);
      restoreIdle(root);
      return;
    }
    snapshotIdle(root);
    showSearching(root);
    root._searchTimer = window.setTimeout(function () {
      root._searchTimer = null;
      runSearch(root, q, false);
    }, SEARCH_DEBOUNCE_MS);
  }

  function resetCategoryTracks(root) {
    if (!root) return;
    root.querySelectorAll('[data-cards-categories-track]').forEach(function (track) {
      if (typeof track.scrollTo === 'function') track.scrollTo({ left: 0, behavior: 'auto' });
      else track.scrollLeft = 0;
    });
  }

  function clearInput(root) {
    var input = root && root.querySelector('[data-search-input]');
    if (!input) return;
    input.value = '';
    syncFilled(root);
    clearSearchTimer(root);
    abortSearch(root);
    restoreIdle(root);
    input.focus();
  }

  function fillFromRecent(root, button) {
    var input = root && root.querySelector('[data-search-input]');
    if (!input || !button) return;
    input.value = normalizeQuery(button.textContent);
    syncFilled(root);
    runSearch(root, input.value, true);
    renderRecents(root);
    input.focus();
  }

  function clearRecents(root) {
    clearStoredRecents();
    renderRecents(root);
    var input = root && root.querySelector('[data-search-input]');
    if (input) input.focus();
  }

  function clearCloseTimer(dialog) {
    if (!dialog) return;
    if (dialog._searchCloseTimer) {
      window.clearTimeout(dialog._searchCloseTimer);
      dialog._searchCloseTimer = null;
    }
    if (dialog._searchCloseHandler) {
      dialog.removeEventListener('transitionend', dialog._searchCloseHandler);
      dialog._searchCloseHandler = null;
    }
  }

  function setOpenButtons(open) {
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function focusInput(root) {
    var input = root && root.querySelector('[data-search-input]');
    if (input) input.focus();
  }

  function openOverlay(dialog, trigger) {
    if (!dialog || dialog.open) {
      if (dialog && dialog.open) {
        renderRecents(dialog);
        snapshotIdle(dialog);
        resetCategoryTracks(dialog);
        focusInput(dialog);
      }
      return;
    }
    closeHeaderDrawer();
    dialog._searchTrigger = trigger || null;
    renderRecents(dialog);
    snapshotIdle(dialog);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    setOpenButtons(true);
    resetCategoryTracks(dialog);

    if (prefersReducedMotion()) {
      dialog.classList.add('is-open');
      focusInput(dialog);
      return;
    }

    dialog.classList.remove('is-open');
    void dialog.offsetWidth;
    window.requestAnimationFrame(function () {
      dialog.classList.add('is-open');
      focusInput(dialog);
    });
  }

  function finishClose(dialog) {
    clearCloseTimer(dialog);
    clearSearchTimer(dialog);
    abortSearch(dialog);
    dialog._searchClosing = false;
    dialog.classList.remove('is-open');
    if (dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    setOpenButtons(false);
    var trigger = dialog._searchTrigger;
    dialog._searchTrigger = null;
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  function requestOverlayClose(dialog) {
    if (!dialog || dialog._searchClosing) return;

    if (prefersReducedMotion() || !dialog.classList.contains('is-open')) {
      finishClose(dialog);
      return;
    }

    dialog._searchClosing = true;
    dialog.classList.remove('is-open');

    function onEnd(event) {
      if (event && event.propertyName && event.propertyName !== 'opacity') return;
      finishClose(dialog);
    }

    dialog._searchCloseHandler = onEnd;
    dialog.addEventListener('transitionend', onEnd);
    dialog._searchCloseTimer = window.setTimeout(onEnd, PANEL_FALLBACK_MS);
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-search-open]');
    if (openBtn) {
      var overlay = overlayRoot();
      if (!overlay) return;
      event.preventDefault();
      openOverlay(overlay, openBtn);
      return;
    }

    var closeBtn = event.target.closest('[data-search-close]');
    if (closeBtn) {
      var closeRoot = closeBtn.closest('[data-site-search]');
      if (closeRoot && closeRoot.matches('[data-search-overlay]')) {
        event.preventDefault();
        requestOverlayClose(closeRoot);
      }
      return;
    }

    var clearBtn = event.target.closest('[data-search-clear]');
    if (clearBtn) {
      event.preventDefault();
      clearInput(clearBtn.closest('[data-site-search]'));
      return;
    }

    var recentBtn = event.target.closest('[data-search-recent]');
    if (recentBtn) {
      event.preventDefault();
      fillFromRecent(recentBtn.closest('[data-site-search]'), recentBtn);
      return;
    }

    var recentsClear = event.target.closest('[data-search-recents-clear]');
    if (recentsClear) {
      event.preventDefault();
      clearRecents(recentsClear.closest('[data-site-search]'));
    }
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-search-input]');
    if (!input) return;
    var root = input.closest('[data-site-search]');
    syncFilled(root);
    scheduleSearch(root, input.value);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-search-form]');
    if (!form) return;
    event.preventDefault();
    var root = form.closest('[data-site-search]');
    var input = form.querySelector('[data-search-input]');
    var query = input ? normalizeQuery(input.value) : '';
    if (!query || !root) return;
    clearSearchTimer(root);
    runSearch(root, query, true);
    renderRecents(root);
  });

  document.addEventListener(
    'cancel',
    function (event) {
      var dialog = event.target.closest('[data-search-overlay]');
      if (!dialog) return;
      event.preventDefault();
      requestOverlayClose(dialog);
    },
    true
  );

  document.addEventListener('joselito:showcase-module', function (event) {
    var detail = (event && event.detail) || {};
    var slug = detail.slug || '';
    var dialog = overlayRoot();
    if (!dialog) return;
    if (slug === 'm26') {
      openOverlay(dialog, null);
      return;
    }
    if (dialog.open) requestOverlayClose(dialog);
  });

  (function syncInitialShowcaseSearch() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('showcase_module') !== 'm26') return;
    var dialog = overlayRoot();
    if (dialog) openOverlay(dialog, null);
  })();

  document.querySelectorAll('[data-site-search]').forEach(function (root) {
    renderRecents(root);
    snapshotIdle(root);
  });
})();
